.layout__container__page__content.declare-gastax {
  background: none;
}
